module.exports = __webpack_public_path__ + "static/img/1.b8e1228.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/sp/1.png
// module id = qCvw
// module chunks = 0